import React, { useEffect } from "react";
import { Footer } from "../Footer";
import analytics from "../services/analytics";
import { Background } from "./Background";
import { CustomizedSolutionsSection } from "./CustomizedSolutionsSection";
import { EvidenceBasedSection } from "./EvidenceBasedSection";
import { Header } from "./Header";
import { MainSection } from "./MainSection";

export const Insurers: React.FC = () => {
  useEffect(() => {
    document.title =
      "Vika - engage your policy holders and let them win health";
    analytics.logPageView("insurers");
  }, []);

  return (
    <Background>
      <Header />
      <MainSection />
      <EvidenceBasedSection />
      <CustomizedSolutionsSection />
      <Footer />
    </Background>
  );
};

export default Insurers;
